export default "__VITE_ASSET__zxjjlydt__"